<template>
  <div></div>
</template>

<script>
export default {
  name: "home",
  components: {},
};
</script>

<style lang="scss" scoped>
</style>
